import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import LoadingImage from "assets/gifs/fractional-logo-blue.gif";
const Loading = ({ width = "100px", height = "100px", text }) => {
  const halfWidth = parseInt(width) / 2;
  const doubleHeight = parseInt(height) * 2;
  return (
    <Stack
      direction={"column"}
      justifyContent="center"
      alignItems="center"
      sx={{
        width: `calc(100vw - ${halfWidth}px)`,
        height: `calc(100vh - ${doubleHeight}px)`,
      }}
    >
      <Stack direction={"column"} justifyContent="center" alignItems="center" sx={{
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        borderRadius: "100%",
        padding: 4,
        boxShadow: 1,
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",

      }}>
        <Box
          component={"img"}
          src={LoadingImage}
          alt="Loading..."
          style={{ width, height }}
        />
      </Stack>
   
    </Stack>
  );
};

export default Loading;
